import gql from "graphql-tag";

export const GET_PORTAL_URL = gql`
    query stripeCustomerPortalUrl($returnUrl: String!, $organizationId: ID) {
        stripeCustomerPortalUrl(
            returnUrl: $returnUrl
            organizationId: $organizationId
        ) {
            ok
            error
            url
        }
    }
`;
